import "../TaskDetails/index.scss";
import "./index.scss";
import useUrlState from "@ahooksjs/use-url-state";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Api from "../../apis/index";
import {
  message,
  Empty,
  Button,
  List,
  Typography,
  Spin,
  Dropdown,
  Badge,
  Tooltip,
} from "antd";
import { useGetState } from "ahooks";
import {
  encryptIdCardAdvanced,
  getFileName,
  getFileSize,
  guid,
  isImage,
} from "../../unit/unit";
import {
  VerticalAlignBottomOutlined,
  ExclamationCircleFilled,
  CheckCircleFilled,
} from "@ant-design/icons";
import ImageModal from "../../components/ImageModal/index";
import ImageDrawer from "../../components/ImageDrawer";
import emptyImg from "../../assets/暂无icon.png";
import { useNavigate } from "react-router-dom";

const { Paragraph } = Typography;

function ImagesPage(props) {
  const { setLoading } = props;
  const { id } = useParams();
  const [state, setState] = useUrlState({});

  const [checkWebList, setCheckWebList] = useState([]);
  const [companyName, setCompanyName, getCompanyName] = useGetState(null);
  const [originCompanyName, setOriginCompanyName] = useState(null);
  const [company, setCompany, getCompany] = useGetState(null);
  const [idCard, setIdCard, getIdCard] = useGetState(null);
  const [area, setArea, getArea] = useGetState(null);

  const [seeType, setSeeType, getSeeType] = useGetState(3);
  const [selectWebId, setSelectWebId, getSelectWebId] = useGetState(null);
  const [webStatusObj, setWebStatusObj, getWebStatusObj] = useGetState({});

  const [imgsList, setImgsList] = useState([]);
  const [showImgsList, setShowImgsList] = useState([]);
  const [imgsLoading, setImgsLoading, getImgsLoading] = useGetState(false);

  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [initialIndex, setInitialIndex] = useState(0);

  const [hasWuDaoPaths, setHasWuDaoPaths] = useState(false);
  const navigate = useNavigate();

  //补录/编辑
  const handleItem = (type) => {
    let params = {
      companyName: companyName,
      task_id: id,
      company: company,
      id_card: idCard,
      area: area,
      web_id: getSelectWebId(),
    };
    if (type === "检索截图") {
      params.type = 1;
    } else if (type === "详情截图/附件") {
      params.type = 2;
    }
    ImageDrawer({
      title: "补录/编辑-" + type,
      ...params,
      onOk: () => {
        getImagesList();
      },
    });
  };

  //获取核查网站列表
  const getCheckWebList = (isFirst) => {
    Api.getCheckWebsList({
      check_id: id,
      name: getCompanyName(),
      company: getCompany(),
      id_card: getIdCard(),
      area: getArea(),
    })
      .then((res) => {
        if (res.code === 200) {
          setCheckWebList(res.data?.web_list || []);
          if (!getSelectWebId()) {
            setSelectWebId(res.data?.web_list[0]?.web_id);
          }
          getImagesList(isFirst);
        } else {
          setLoading(false);
          message.error(res.message);
          if (res.code === -1) {
            navigate("/home");
          }
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  //获取核查网站状态
  const getCheckWebStatus = () => {
    Api.getTaskInfo(
      id,
      getCompanyName(),
      getCompany(),
      getIdCard(),
      getArea()
    ).then((res) => {
      if (res.code === 200) {
        let obj = {};
        (res.data?.data || []).forEach((item) => {
          (item.list || []).forEach((web) => {
            obj[web.web_id] = web.check_res;
          });
        });
        setWebStatusObj(obj);
      } else {
        message.error(res.message);
        setWebStatusObj({});
      }
    });
  };

  //获取图片列表
  const getImagesList = (isFirst) => {
    setImgsLoading(true);
    let params = {
      name: getCompanyName(),
      company: getCompany(),
      id_card: getIdCard(),
      area: getArea(),
      check_id: id,
      web_id: getSelectWebId(),
    };
    Api.getCheckImagesPaths(params)
      .then((res) => {
        if (res.code === 200) {
          let list = [];
          (res.data?.full_detail_paths || []).forEach((item, index) => {
            item.type = 2;
            item.index = index + 1;
            list.push(item);
            item.isImage = isImage(item.screenshot_path);
          });
          (res.data?.full_list_search_paths || []).forEach((item, index) => {
            item.type = 1;
            item.index = index + 1;
            list.push(item);
            item.isImage = isImage(item.screenshot_path);
          });
          (res.data?.full_wudao_detail_paths || []).forEach((item, index) => {
            item.type = 4;
            item.index = index + 1;
            list.push(item);
            item.isImage = isImage(item.screenshot_path);
          });
          setHasWuDaoPaths((res.data?.full_wudao_detail_paths || []).length > 0);
          setImgsList(list);
          if (isFirst) {
            // let index = list.findIndex((v) => v.type === getSeeType());
            // if (index === -1) {
            //   index = 0;
            // }
            let has = list.some((v) => v.type === getSeeType() && v.isImage);
            setInitialIndex(0);
            setImageModalVisible(has);
          }
        } else {
          message.error(res.message);
        }
        setLoading(false);
        setImgsLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setImgsLoading(false);
      });
  };

  //下载图片
  const handleDownload = async (url) => {
    if (!url) return;
    // const link = document.createElement("a");
    // link.style.display = "none";
    // link.href = url;
    // link.download = getFileName(url); // 设置下载的文件名
    // link.target = "_blank";
    // document.body.appendChild(link);
    // link.click();
    // link.remove();
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      // 关键：创建新的 Blob 并指定类型
      const downloadBlob = new Blob([blob], {
        type: "application/octet-stream", // 强制为二进制流
      });

      const blobUrl = URL.createObjectURL(downloadBlob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = getFileName(url) || "image.jpg";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // 释放URL对象
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("下载失败:", error);
      // 备选方案：在新窗口打开
      window.open(url, "_blank");
    }
  };

  //预览图片
  const previewImage = (url, index) => {
    if (!url) return;
    //判断是否为图片
    if (isImage(url)) {
      setInitialIndex(index);
      setImageModalVisible(true);
    } else {
      // 非图片格式，直接打开链接
      window.open(url, guid());
      // const link = document.createElement("a");
      // link.style.display = "none";
      // link.href = url;
      // link.download = getFileName(url); // 设置下载的文件名
      // link.target = "_blank";
      // document.body.appendChild(link);
      // link.click();
      // link.remove();
    }
  };

  //获取文件图标
  const getIcon = (url) => {
    if (!url) return;
    const index = url.lastIndexOf(".");
    //获取后缀
    const ext = url.substr(index + 1);
    if (["png", "jpg", "jpeg", "webp"].indexOf(ext.toLowerCase()) !== -1) {
      return (
        <svg
          t="1757656558106"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="5494"
          width="14"
          height="14"
        >
          <path
            d="M335.36 440.32c38.4 0 71.68-30.72 71.68-71.68 0-38.4-30.72-71.68-71.68-71.68-38.4 0-71.68 30.72-71.68 71.68 2.56 40.96 33.28 71.68 71.68 71.68z m0 0M652.8 396.8L445.44 691.2 337.92 540.16 158.72 793.6h704L652.8 396.8z m0 0"
            fill="#0068B2"
            p-id="5495"
          ></path>
          <path
            d="M934.4 107.52H89.6c-20.48 0-35.84 15.36-35.84 35.84V883.2c0 20.48 15.36 35.84 35.84 35.84h844.8c20.48 0 35.84-15.36 35.84-35.84V143.36c0-20.48-15.36-35.84-35.84-35.84z m-35.84 739.84H125.44V176.64h775.68v670.72h-2.56z m0 0"
            fill="#0068B2"
            p-id="5496"
          ></path>
        </svg>
      );
    } else if (["doc", "docx"].indexOf(ext.toLowerCase()) !== -1) {
      return (
        <svg
          t="1758162506371"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3933"
          width="14"
          height="14"
        >
          <path
            d="M920.64 216.07a32.37 32.37 0 0 0-35.94-36.41c-99.41-1.93-198.92 0-298.53-0.87v-76.2H530.5c-142.67 26.01-285.43 50.86-428.1 76.39V845.6c141.99 25.43 283.98 49.7 425.98 75.81h57.8v-74.85h279.36c15.89-0.96 33.43 0 47.01-9.63 10.89-17.24 8.09-38.53 9.05-57.8-0.96-187.37 0.68-375.4-0.96-563.06zM413.7 650.35h-53.51c-12.58-52.9-33.57-130.09-42-171.01h-0.35c-8.68 42.51-30.24 122.92-42.99 171.01h-53.47l-60.81-238.89h55.09c22.39 109.76 32.58 158.45 35.38 184.73h0.35c9.08-43.88 32.15-127.03 46.08-184.73h46.41c12.28 45.83 36.44 138.52 44.22 182.24h0.35c7.93-52.6 31.39-145.12 39.78-182.24h50.17l-64.7 238.89z m479.58 166.63H586.17v-76.2h241.98v-38.53H586.17v-47.2h241.98v-38.54H586.17v-47.2h241.98v-38.53H586.17v-48.16h241.98v-37.09H586.17v-48.16h241.98V359.8H586.17v-47.68h241.98v-38.05H586.17V207.4h307.11v609.58z"
            fill="#0068b2"
            p-id="3934"
          ></path>
        </svg>
      );
    } else if (["pdf"].indexOf(ext.toLowerCase()) !== -1) {
      return (
        <svg
          t="1758162755238"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="5342"
          width="12"
          height="12"
        >
          <path
            d="M535.198324 0h69.53853v95.276816c124.175945 0.677323 248.351891-1.354647 373.205159 0.677324a40.6394 40.6394 0 0 1 45.154889 45.154889c1.919083 234.579649 0 469.272186 1.128872 703.851835-1.128872 24.044979 2.257744 50.686363-11.288722 72.022049-17.045971 12.417595-38.946092 11.288722-58.814243 11.288722H604.962628v95.276816h-72.925146C354.917429 990.924044 177.458715 960.557381 0 928.723184V95.502591C178.361812 63.555507 356.836512 32.51152 535.198324 0z"
            fill="#0068B2"
            p-id="5343"
          ></path>
          <path
            d="M604.736854 130.949179h383.816558v762.101642h-383.816558v-95.276816h302.42487v-47.638408H604.736854v-59.491567h302.42487V643.457171H604.736854v-60.056002h302.42487v-47.638409H604.736854v-59.491566h302.42487V428.971447H604.736854v-59.830228h302.42487v-47.638408H604.736854V261.898357h302.42487v597.17341H604.736854z"
            fill="#FFFFFF"
            p-id="5344"
          ></path>
          <path
            d="M645.489141 529.66685h302.424871v47.638409H645.489141zM645.489141 611.510087h302.424871v47.638408H645.489141zM645.489141 693.353324h302.424871v47.638408H645.489141zM596.383199 775.19656h351.530813v47.638409H596.383199z"
            fill="#0068B2"
            p-id="5345"
          ></path>
          <path
            d="M180.619557 317.325984c59.265792 2.822181 130.949179-24.044979 180.619557 21.335685 46.961085 58.475582 34.54349 165.831331-35.107927 200.713483-24.722302 12.982031-53.169882 11.288722-80.037041 10.272737v130.949179L180.619557 675.065594c-0.903098-119.208908-1.128872-238.530702 0-357.73961z"
            fill="#FFFFFF"
            p-id="5346"
          ></path>
          <path
            d="M245.642597 377.720648c21.448572-1.015985 48.089957-5.079925 62.539522 15.578437a82.407673 82.407673 0 0 1 1.467534 73.263808c-12.417595 22.577445-40.526513 20.771249-62.313747 23.367655-2.257744-37.365671-2.03197-74.731342-1.693309-112.2099zM885.713152 379.865505a83.988094 83.988094 0 0 1-48.315732-19.642376 460.57987 460.57987 0 0 0-77.666409 24.835189c-20.3197 36.011024-39.171866 54.411641-55.540514 54.411641a17.384632 17.384632 0 0 1-9.821188-2.596406 19.416602 19.416602 0 0 1-11.288723-17.723294c0-5.870136 1.354647-22.577445 63.329733-49.105942a467.917539 467.917539 0 0 0 34.656377-81.278801c-7.902106-15.691324-24.835189-54.298754-13.094918-73.941131a20.658362 20.658362 0 0 1 20.206813-10.498511 21.900121 21.900121 0 0 1 17.045971 8.466541c8.466542 11.288722 7.789218 36.688347-3.27373 73.376695A196.988204 196.988204 0 0 0 842.70312 338.661669a221.14607 221.14607 0 0 1 41.090949-4.515489c30.705325 0.677323 35.333701 15.014001 34.656377 23.59343 0 22.577445-21.56146 22.577445-32.624407 22.577444z m-185.022159 42.106935l2.257745-0.564436a45.154889 45.154889 0 0 0 23.932091-16.820197 56.443612 56.443612 0 0 0-26.189836 17.384633z m93.357734-200.261934h-2.144858a4.402602 4.402602 0 0 0-2.82218 0.677323 52.492559 52.492559 0 0 0 4.176827 33.866167 53.282769 53.282769 0 0 0 0.790211-34.54349zM790.210561 317.551758v1.24176l-0.677323-0.677324c-5.418587 14.336677-11.288722 28.44758-18.061956 42.332709l1.128872-0.677323V361.239114A346.338 346.338 0 0 1 812.788006 348.595745l-0.677324-0.564436h1.806196a196.310881 196.310881 0 0 1-23.706317-30.479551z m94.599493 34.769265a66.151913 66.151913 0 0 0-18.174843 1.693308 50.686363 50.686363 0 0 0 20.997024 6.660347 26.076949 26.076949 0 0 0 13.885128-1.580422c-0.451549-2.596406-3.273729-6.773233-17.158858-6.773233z"
            fill="#0068B2"
            p-id="5347"
          ></path>
        </svg>
      );
    } else if (["xls", "xlsx"].indexOf(ext.toLowerCase()) !== -1) {
      return (
        <svg
          t="1758162814835"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="6496"
          width="14"
          height="14"
        >
          <path
            d="M531.243 85.333H588.8v79.403h290.73a87.467 87.467 0 0 1 48.64 10.027 97.835 97.835 0 0 1 10.027 50.176q-0.81 258.602 0 516.821a425.643 425.643 0 0 1-3.328 86.827c-3.797 20.693-28.074 21.333-44.202 21.888H589.312v88.192h-60.245c-148.096-27.094-295.979-52.523-443.734-79.019V164.864c148.694-26.539 297.344-52.608 445.91-79.53z"
            fill="#0068B2"
            p-id="6497"
          ></path>
          <path
            d="M586.581 195.115h321.664v624.213H586.581v-59.435h77.995V690.56h-77.995v-40.064h77.995v-68.95h-77.995v-39.594h77.995v-69.461h-77.995v-40.064h77.995v-68.864h-77.995v-40.064h77.995V254.42h-77.995z"
            fill="#FFFFFF"
            p-id="6498"
          ></path>
          <path
            d="M703.53 254.037h136.534v69.803H703.531z"
            fill="#0068B2"
            p-id="6499"
          ></path>
          <path
            d="M373.973 346.368q33.195-2.432 66.304-4.267-39.04 81.835-78.592 163.542c26.752 55.808 54.187 110.933 80.726 167.168l-70.614-4.523a1202.347 1202.347 0 0 1-48.64-125.397c-13.226 40.362-32.17 78.805-47.402 118.442-21.334 0-42.667-1.194-64-2.133 25.002-50.432 49.237-100.907 75.05-150.613-21.973-51.2-45.994-101.718-68.608-152.832l64.256-3.712c14.55 39.04 30.251 77.482 42.368 117.546 13.526-42.666 32.896-82.346 49.152-123.306z"
            fill="#FFFFFF"
            p-id="6500"
          ></path>
          <path
            d="M703.53 362.112h136.534v69.803H703.531z m0 109.653h136.534v69.931H703.531z m0 109.782h136.534v69.802H703.531z m0 109.781h136.534v69.803H703.531z"
            fill="#0068B2"
            p-id="6501"
          ></path>
        </svg>
      );
    }
  };

  //初始化
  useEffect(() => {
    //解码
    try {
      let str = window.atob(state.q);
      str = window.decodeURIComponent(str);
      const obj = JSON.parse(str);
      setCompanyName(obj.companyName);
      setOriginCompanyName(obj.originCompanyName);
      setSeeType(obj.type); //1:检索截图 2:详情截图/附件 3:全部 4:吾道补充
      setSelectWebId(obj.web_id ? Number(obj.web_id) : null);
      setCompany(obj.company || "");
      setIdCard(obj.idCard || "");
      setArea(obj.area || "");
    } catch (error) {
      setState({ q: undefined });
      window.location.reload();
    }
    setTimeout(() => {
      getCheckWebList(true);
      getCheckWebStatus();
    }, 10);
  }, []);

  useEffect(() => {
    let list = [];
    if (getSeeType() === 1) {
      list = imgsList.filter((v) => v.type === 1);
    } else if (getSeeType() === 2) {
      list = imgsList.filter((v) => v.type === 2);
    } else if (getSeeType() === 4) {
      list = imgsList.filter((v) => v.type === 4);
    }  else {
      list = imgsList;
    }
    setShowImgsList(list);
  }, [imgsList, seeType]);

  return (
    <Spin
      tip="加载中..."
      spinning={imgsLoading}
      wrapperClassName="taskDetailsSpin"
    >
      <div className="taskDetails">
        <div className="targetListBox">
          <div className="companyItem">
            <svg
              t="1757648793451"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2428"
              width="16"
              height="16"
            >
              <path
                fill="#006AB2"
                d="M576 268.8h313.6c12.8 0 19.2-12.8 19.2-25.6V166.4c0-12.8-6.4-25.6-19.2-25.6H518.4c-19.2 0-25.6 25.6-12.8 38.4l57.6 83.2c0 6.4 6.4 6.4 12.8 6.4z"
                p-id="2429"
              ></path>
              <path
                fill="#006AB2"
                d="M902.4 320H576c-12.8 0-32-6.4-38.4-25.6L409.6 128c-12.8-12.8-25.6-19.2-44.8-19.2H128c-32 0-57.6 32-57.6 64v627.2c0 38.4 25.6 64 57.6 64h774.4c32 0 57.6-32 57.6-64V384c0-38.4-25.6-64-57.6-64z m-268.8 352c0 19.2-12.8 32-32 32H204.8c-19.2 0-32-12.8-32-32s12.8-32 32-32h403.2c12.8 0 25.6 12.8 25.6 32z m166.4 0c0 19.2-12.8 32-32 32h-25.6c-19.2 0-32-12.8-32-32s12.8-32 32-32h25.6c19.2 0 32 12.8 32 32z"
                p-id="2430"
              ></path>
            </svg>
            <Tooltip
              placement="bottom"
              title={
                <div className="targetNameTooltipDiv">
                  <div>{companyName}</div>
                  {companyName === originCompanyName ? null : (
                    <div>
                      <span className="targetNameTooltipTitleSpan">
                        现用名:{" "}
                      </span>
                      <span>{originCompanyName}</span>
                    </div>
                  )}
                  {company && (
                    <div>
                      <span className="targetNameTooltipTitleSpan">
                        企业名称:{" "}
                      </span>
                      <span>{company}</span>
                    </div>
                  )}
                  {idCard && (
                    <div>
                      <span className="targetNameTooltipTitleSpan">
                        身份证号:{" "}
                      </span>
                      <span>
                        {encryptIdCardAdvanced(idCard, {
                          keepStart: 4,
                        })}
                      </span>
                    </div>
                  )}
                  {area && (
                    <div>
                      <span className="targetNameTooltipTitleSpan">地区: </span>
                      <span>{area}</span>
                    </div>
                  )}
                </div>
              }
            >
              <Paragraph
                style={{ maxWidth: "calc(100% - 20px)", marginBottom: "0" }}
                // ellipsis={{
                //   tooltip:
                //     companyName +
                //     (originCompanyName === companyName
                //       ? ""
                //       : `（${originCompanyName}曾用名）`),
                //   rows: 1,
                // }}
              >
                {companyName}
                {/* {companyName === originCompanyName
                ? ""
                : `（${originCompanyName}曾用名）`} */}
              </Paragraph>
            </Tooltip>
          </div>
          <div className="companyWebItem">
            {checkWebList.map((web, index) => {
              return (
                <div
                  className={
                    getSelectWebId() === web.web_id
                      ? "webItem activeWebItem"
                      : "webItem"
                  }
                  onClick={() => {
                    if (getImgsLoading()) {
                      return;
                    }
                    if (getSelectWebId() !== web.web_id) {
                      setSelectWebId(web.web_id);
                      setTimeout(() => {
                        getImagesList();
                      }, 20);
                    }
                  }}
                >
                  <Badge
                    dot
                    count={
                      webStatusObj[web.web_id] === 2 ? (
                        <ExclamationCircleFilled
                          style={{ color: "#FE545F", fontSize: "12px" }}
                        />
                      ) : webStatusObj[web.web_id] === 50 ? (
                        <ExclamationCircleFilled
                          style={{ color: "#FEC054", fontSize: "12px" }}
                        />
                      ) : (
                        <></>
                      )
                    }
                    className="webBadge"
                    offset={[2, 2]}
                  >
                    <svg
                      t="1757648793451"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2428"
                      width="14"
                      height="14"
                    >
                      <path
                        fill="#006AB2"
                        d="M576 268.8h313.6c12.8 0 19.2-12.8 19.2-25.6V166.4c0-12.8-6.4-25.6-19.2-25.6H518.4c-19.2 0-25.6 25.6-12.8 38.4l57.6 83.2c0 6.4 6.4 6.4 12.8 6.4z"
                        p-id="2429"
                      ></path>
                      <path
                        fill="#006AB2"
                        d="M902.4 320H576c-12.8 0-32-6.4-38.4-25.6L409.6 128c-12.8-12.8-25.6-19.2-44.8-19.2H128c-32 0-57.6 32-57.6 64v627.2c0 38.4 25.6 64 57.6 64h774.4c32 0 57.6-32 57.6-64V384c0-38.4-25.6-64-57.6-64z m-268.8 352c0 19.2-12.8 32-32 32H204.8c-19.2 0-32-12.8-32-32s12.8-32 32-32h403.2c12.8 0 25.6 12.8 25.6 32z m166.4 0c0 19.2-12.8 32-32 32h-25.6c-19.2 0-32-12.8-32-32s12.8-32 32-32h25.6c19.2 0 32 12.8 32 32z"
                        p-id="2430"
                      ></path>
                    </svg>
                    <Paragraph
                      style={{ width: "100%", marginBottom: "0" }}
                      ellipsis={{ tooltip: `${web.web_name}` }}
                    >
                      {index + 1}.{web.web_name}
                    </Paragraph>
                  </Badge>
                </div>
              );
            })}
          </div>
        </div>
        <div style={{ height: "100%", overflow: "hidden", width: "1000px" }}>
          {imgsList.length === 0 ? (
            <div className="emptyBox">
              <Empty image={emptyImg} description="暂无数据">
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: "检索截图",
                        label: <span>检索截图</span>,
                      },
                      {
                        key: "详情截图/附件",
                        label: <span>详情截图/附件</span>,
                      },
                    ],
                    onClick: ({ key }) => {
                      handleItem(key);
                    },
                  }}
                >
                  <Button
                    type="primary"
                    icon={
                      <svg
                        t="1757655045572"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="4326"
                        width="16"
                        height="16"
                      >
                        <path
                          fill="#fff"
                          d="M921.6 25.6c-19.2-19.2-38.4-25.6-64-25.6H166.4c-51.2 0-83.2 38.4-83.2 83.2v857.6c0 6.4 0 12.8 6.4 19.2 12.8 38.4 44.8 64 83.2 64h684.8c44.8 0 83.2-38.4 83.2-76.8V83.2c6.4-19.2 0-38.4-19.2-57.6z m-704 185.6h537.6c12.8 0 25.6 12.8 25.6 25.6s-12.8 25.6-25.6 25.6H217.6c-19.2 6.4-32-6.4-32-19.2 0-19.2 12.8-32 32-32zM512 454.4c0 12.8-12.8 25.6-25.6 25.6H217.6c-12.8 0-25.6-12.8-25.6-25.6s12.8-25.6 25.6-25.6h268.8c12.8 0 25.6 12.8 25.6 25.6z m-134.4 192H217.6c-12.8 0-25.6-12.8-25.6-25.6s12.8-25.6 25.6-25.6h160c12.8 0 25.6 12.8 25.6 25.6s-12.8 25.6-25.6 25.6zM832 569.6l-320 320s-6.4 0-6.4 6.4l-108.8 32c-19.2 6.4-25.6-6.4-25.6-25.6l32-108.8s0-6.4 6.4-6.4l320-320c6.4-6.4 19.2-6.4 25.6 0L832 544c6.4 6.4 6.4 25.6 0 25.6z m70.4-76.8l-12.8 19.2c-6.4 6.4-19.2 6.4-25.6 0l-76.8-70.4c-6.4-6.4-6.4-19.2 0-25.6l32-25.6c19.2-19.2 32-19.2 51.2 0l32 32c25.6 25.6 25.6 57.6 0 70.4z"
                          p-id="4327"
                        ></path>
                      </svg>
                    }
                  >
                    补录/编辑
                  </Button>
                </Dropdown>
              </Empty>
            </div>
          ) : (
            <div
              className="taskDetailsBox"
              style={{ padding: "0px", height: "100%", overflow: "hidden" }}
            >
              <div className="supplementaryBtnBox">
                <div className="supplementaryBtnBoxLeft">
                  {(hasWuDaoPaths ? [
                    {
                      label: "全部",
                      value: 3,
                    },
                    {
                      label: "检索截图",
                      value: 1,
                    },
                    {
                      label: "详情截图/附件",
                      value: 2,
                    },
                    {
                      label: "吾道补充数据",
                      value: 4,
                    },
                  ] : [
                    {
                      label: "全部",
                      value: 3,
                    },
                    {
                      label: "检索截图",
                      value: 1,
                    },
                    {
                      label: "详情截图/附件",
                      value: 2,
                    },
                  ]).map((type) => (
                    <div
                      key={type.value}
                      className={
                        seeType === type.value
                          ? "typeItem activeTypeItem"
                          : "typeItem"
                      }
                      onClick={() => {
                        if (seeType !== type.value) {
                          setInitialIndex(0);
                          setSeeType(type.value);
                        }
                      }}
                    >
                      {type.label}
                    </div>
                  ))}
                </div>
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: "检索截图",
                        label: <span>检索截图</span>,
                      },
                      {
                        key: "详情截图/附件",
                        label: <span>详情截图/附件</span>,
                      },
                    ],
                    onClick: ({ key }) => {
                      handleItem(key);
                    },
                  }}
                >
                  <Button
                    type="primary"
                    icon={
                      <svg
                        t="1757655045572"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="4326"
                        width="16"
                        height="16"
                      >
                        <path
                          fill="#fff"
                          d="M921.6 25.6c-19.2-19.2-38.4-25.6-64-25.6H166.4c-51.2 0-83.2 38.4-83.2 83.2v857.6c0 6.4 0 12.8 6.4 19.2 12.8 38.4 44.8 64 83.2 64h684.8c44.8 0 83.2-38.4 83.2-76.8V83.2c6.4-19.2 0-38.4-19.2-57.6z m-704 185.6h537.6c12.8 0 25.6 12.8 25.6 25.6s-12.8 25.6-25.6 25.6H217.6c-19.2 6.4-32-6.4-32-19.2 0-19.2 12.8-32 32-32zM512 454.4c0 12.8-12.8 25.6-25.6 25.6H217.6c-12.8 0-25.6-12.8-25.6-25.6s12.8-25.6 25.6-25.6h268.8c12.8 0 25.6 12.8 25.6 25.6z m-134.4 192H217.6c-12.8 0-25.6-12.8-25.6-25.6s12.8-25.6 25.6-25.6h160c12.8 0 25.6 12.8 25.6 25.6s-12.8 25.6-25.6 25.6zM832 569.6l-320 320s-6.4 0-6.4 6.4l-108.8 32c-19.2 6.4-25.6-6.4-25.6-25.6l32-108.8s0-6.4 6.4-6.4l320-320c6.4-6.4 19.2-6.4 25.6 0L832 544c6.4 6.4 6.4 25.6 0 25.6z m70.4-76.8l-12.8 19.2c-6.4 6.4-19.2 6.4-25.6 0l-76.8-70.4c-6.4-6.4-6.4-19.2 0-25.6l32-25.6c19.2-19.2 32-19.2 51.2 0l32 32c25.6 25.6 25.6 57.6 0 70.4z"
                          p-id="4327"
                        ></path>
                      </svg>
                    }
                  >
                    补录/编辑
                  </Button>
                </Dropdown>
              </div>
              <List
                className="imgListBox"
                dataSource={showImgsList}
                bordered={false}
                locale={{
                  emptyText: (
                    <Empty image={emptyImg} description="暂无数据"></Empty>
                  ),
                }}
                renderItem={(item, index) => (
                  <List.Item>
                    <div
                      className={
                        index % 2 !== 0 ? "listItem" : "listItem listItemBg"
                      }
                    >
                      <div
                        className="imgNameBox"
                        onClick={(e) => {
                          previewImage(item.screenshot_path, index);
                        }}
                      >
                        {getIcon(item.screenshot_path)}
                        <Paragraph
                          style={{
                            maxWidth: "calc(100% - 40px)",
                            marginBottom: "0",
                          }}
                          ellipsis={{
                            tooltip: `${getFileName(item.screenshot_path)}`,
                          }}
                        >
                          {getFileName(item.screenshot_path)}
                        </Paragraph>
                        <VerticalAlignBottomOutlined
                          className="downloadIcon"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDownload(item.screenshot_path);
                          }}
                        />
                      </div>
                      <div className="imgDateBox">
                        {item.watermark_time || item.create_time || "-"}
                      </div>
                      <div className="imgSizeBox">
                        {getFileSize(item.size_kb) || "-"}
                      </div>
                    </div>
                  </List.Item>
                )}
              />
            </div>
          )}
        </div>
      </div>
      <ImageModal
        open={imageModalVisible}
        onClose={() => setImageModalVisible(false)}
        imgsList={showImgsList
          .filter((_) => isImage(_.screenshot_path))
          .map((item) => {
            let screenshot_path = item.screenshot_path;
            screenshot_path = encodeURI(screenshot_path);
            if (item.is_new_add) {
              return screenshot_path + "?t=" + new Date().getTime();
            }
            return screenshot_path;
          })}
        initialIndex={initialIndex}
      ></ImageModal>
    </Spin>
  );
}
export default ImagesPage;
